export default __webpack_public_path__ + "static/media/Ring of Resolve.8646fe43.jpg";